<template>
  <v-row justify="center">
    <v-col cols="12" lg="8" xl="6" class="d-flex" align="center">
      <v-container class="text-center pa-0">
        <v-alert
          v-model="errorMsgAlert"
          close-text="Close Alert"
          class="alert-text my-5"
          color="error"
          dark
          dismissible
          ref="snackbarError"
        >
          {{ $t(errorMsg) }}
        </v-alert>

        <v-card class="card py-6 mt-6">
          <v-btn-toggle v-model="selection" class="mb-3" group mandatory>
            <v-col>
              <v-btn
                value="Register and/or Donate"
                class="btn-text btn-border btn-multiline rounded mb-5"
                style="background-color: transparent"
                elevation="3"
                x-large
                block
              >
                <v-icon
                  v-if="selection == 'Register and/or Donate'"
                  class="pr-2"
                >
                  mdi-radiobox-marked
                </v-icon>
                <v-icon v-else class="pr-2"> mdi-radiobox-blank </v-icon>
                <span class="text-wrap" translate>
                  {{ $t(["Register and/or Donate"]) }}
                </span>
              </v-btn>

              <v-btn
                value="Donation"
                class="btn-text btn-border btn-multiline rounded"
                style="background-color: transparent"
                elevation="3"
                x-large
                block
              >
                <v-icon v-if="selection == 'Donation'" class="pr-2">
                  mdi-radiobox-marked
                </v-icon>
                <v-icon v-else class="pr-2"> mdi-radiobox-blank </v-icon>
                <span class="text-wrap" translate>
                  {{ $t(["Donate Only"]) }}
                </span>
              </v-btn>
            </v-col>
          </v-btn-toggle>

          <v-row justify="center">
            <v-form ref="registerAndDonateForm">
              <div style="width: 280px">
                <!-- <div placeholder="{{ 'Phone Number' | translate }}"></div> -->
                <v-text-field
                  :label="$t(['Phone Number'])"
                  v-model="phoneNumber"
                  type="tel"
                  class="centered-input error-field"
                  v-mask="'(###) ###-####'"
                  :rules="rules.phoneNumber"
                >
                </v-text-field>
              </div>
            </v-form>
          </v-row>
        </v-card>
      </v-container>
    </v-col>

    <v-col cols="10" md="6" lg="6" xl="4">
      <v-btn
        class="btn-text btn-multiline mb-10"
        color="primary"
        x-large
        block
        :loading="sendBtnLoading"
        @click="sendToDonor()"
      >
        <span class="text-wrap" translate>
          {{ $t(["Next: Send"]) }}
        </span>
      </v-btn>

      <v-btn
        class="btn-text"
        x-large
        block
        translate
        @click="$router.push('/home')"
      >
        {{ $t(["Back"]) }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";

import { useAuthenicationStore } from "../store/authenication";
import { useOrderStore } from "../store/order";

export default {
  name: "RegisterAndDonate",
  data() {
    return {
      selection: [],
      phoneNumber: "",
      errorMsgAlert: false,
      errorMsg: "",
      sendBtnLoading: false,
      rules: {
        phoneNumber: [],
      },
    };
  },
  setup() {
    const authStore = useAuthenicationStore();
    const orderStore = useOrderStore();

    return {
      authStore,
      orderStore,
    };
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.registerAndDonateForm.resetValidation();
    },
  },
  methods: {
    setFieldValidationRules() {
      this.rules.phoneNumber = [
        (v) => !!v || this.$gettext(this.$t(["Required"])),
        (v) =>
          (v || "").length >= 14 ||
          this.$gettext(this.$t(["Invalid phone number"])),
      ];
    },
    async sendToDonor() {
      this.sendBtnLoading = true;

      await this.setFieldValidationRules();

      if (this.$refs.registerAndDonateForm.validate()) {
        try {
          await Auth.currentSession().then(async (data) => {
            await this.orderStore
              .newOrderApi(
                {
                  eventName: this.authStore.runSiteInfo.eventName,
                  type: "RegisterAndDonate",
                  status: "Pending",
                  selection: this.selection,
                  phoneNumber: this.phoneNumber,
                  language: this.$i18n.locale,
                },
                data.idToken.jwtToken
              )
              .then((response) => {
                // console.log(response);

                if (response.success) {
                  this.$router.replace({
                    name: "Home",
                    params: {
                      success: true,
                      message: this.$gettext(
                        "Successfully sent order form SMS"
                      ),
                    },
                  });
                } else {
                  throw response.message;
                }
              });
          });
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          // Scroll to first error
          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }
      }

      this.sendBtnLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// Center error message
div ::v-deep .v-messages {
  text-align: center;
}
</style>
